import ProjectSettingsForm from '@/app/components/features/projects/ProjectSettingsForm';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(home)/settings/_layout/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProjectSettingsForm />;
}
